import React from 'react';

interface AttendanceCardProps {
  title: string;
  value: number;
  iconClass: string;
  bgClass: string;
}

const AttendanceSummaryCard: React.FC<AttendanceCardProps> = ({ title, value, iconClass, bgClass }) => (
  <div className="col-xl-3 col-md-6 d-flex">
    <div className="card flex-fill">
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0 me-2">
              <span className={`p-2 br-10 ${bgClass} d-flex align-items-center justify-content-center`}>
                <i className={iconClass}></i>
              </span>
            </div>
            <div>
              <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">{title}</p>
              <h4>{value}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AttendanceSummaryCard;
